import {management} from '../../../../index'
import {FarmsDapRepository} from "../../../infra/knex/repositories/farmsDapRepository"

import {GetFarmDapByFarmAndDAPUseCase} from "./getByFarmAndDAP"


export const getFarmDapByFarmAndDAPUseCase=()=>{
  const farmsDapRepository= new FarmsDapRepository(management)

  const getFarmDapByFarmAndDAPUseCase=new GetFarmDapByFarmAndDAPUseCase(farmsDapRepository)
  return getFarmDapByFarmAndDAPUseCase
}
